import { StyledToolbarButton, StyledTooltip } from '../../../../shared/styles/components/integrations.styles';
import { useBulkEditState, useGetBulkEditItemsFromSelection } from './bulk-edit.state';
import { useMutationWithCacheUpdate, useTableDataState } from '../../state/table-data.state';

import cloneDeep from 'lodash/cloneDeep';
import inactivateIcon from '@ingka/ssr-icon/paths/clipboard-strikethrough';
import { set } from 'lodash';
import { useMemo } from 'react';

export const BulkEditInactivateButton = () => {
   const { bulkEditSubItems, onlyLockedSubItems } = useGetBulkEditItemsFromSelection();
   const sharedSubItems = bulkEditSubItems.flatMap((s) => s.subItems);

   // eslint-disable-next-line react-hooks/exhaustive-deps
   const areAnyActive = useMemo(() => sharedSubItems.map((s) => s.active).includes(true), [bulkEditSubItems]);

   const tooltipText =
      !areAnyActive || onlyLockedSubItems
         ? 'You need to select unlocked active materials to inactivate'
         : 'Inactivate all active materials in selection';

   const mutate = useMutationWithCacheUpdate('Material(s) successfully inactivated');

   const onClick = () => {
      const updated = sharedSubItems
         .filter((s) => !s.locked)
         .map((subItem) => set(cloneDeep(subItem), 'active', false));

      const updatedIds = new Set(updated.map((u) => `${u.parentId}:${u.id}`));
      const previousBulkValues = new Map(sharedSubItems.map((s) => [`${s.parentId}:${s.id}`, s.active]));
      const previousTableValues = new Map(sharedSubItems.map((s) => [`${s.parentId}:${s.id}`, s.active]));

      useBulkEditState.setState((state) => ({
         tableData: state.tableData.map((item) => {
            const updatedSubItems = item.subItems.map((s) =>
               updatedIds.has(`${s.parentId}:${s.id}`) ? { ...s, active: false } : s
            );
            return {
               ...item,
               subItems: updatedSubItems,
               inactive: updatedSubItems.filter((s) => !s.active).length,
            };
         }),
      }));

      useTableDataState.setState((state) => ({
         data: state.data.map((item) => ({
            ...item,
            subItems: item.subItems?.map((s) =>
               updatedIds.has(`${s.parentId}:${s.id}`) ? { ...s, active: false } : s
            ),
         })),
      }));

      mutate(updated, {
         onError: () => {
            useBulkEditState.setState((state) => ({
               tableData: state.tableData.map((item) => {
                  const rolledBackSubItems = item.subItems.map((s) =>
                     previousBulkValues.has(`${s.parentId}:${s.id}`)
                        ? { ...s, active: previousBulkValues.get(`${s.parentId}:${s.id}`)! }
                        : s
                  );
                  return {
                     ...item,
                     subItems: rolledBackSubItems,
                     inactive: rolledBackSubItems.filter((s) => !s.active).length,
                  };
               }),
            }));
            useTableDataState.setState((state) => ({
               data: state.data.map((item) => ({
                  ...item,
                  subItems: item.subItems?.map((s) =>
                     previousTableValues.has(`${s.parentId}:${s.id}`)
                        ? { ...s, active: previousTableValues.get(`${s.parentId}:${s.id}`)! }
                        : s
                  ),
               })),
            }));
         },
      });
   };

   return (
      <StyledTooltip title={tooltipText}>
         <div>
            <StyledToolbarButton
               ssrIcon={inactivateIcon}
               iconOnly={true}
               small={true}
               onClick={onClick}
               disabled={!areAnyActive || onlyLockedSubItems}
            />
         </div>
      </StyledTooltip>
   );
};